import { j as o } from "./kezios-design-system.esm172.js";
import { Container as n, Flex as p } from "@mantine/core";
import { HeroTitle as c } from "./kezios-design-system.esm118.js";
import { SectionLayout as l } from "./kezios-design-system.esm96.js";
import { Spacing as r } from "./kezios-design-system.esm135.js";
const h = ({
  title: t,
  subtitle: e,
  cta: s,
  decoration: i = void 0,
  ...m
}) => /* @__PURE__ */ o.jsx(n, { style: { width: "100%" }, size: "100%", bg: "gray.0", ...m, children: /* @__PURE__ */ o.jsx(l, { pt: r.s6, pb: r.s24, children: /* @__PURE__ */ o.jsxs(p, { direction: "column", gap: r.s32, children: [
  /* @__PURE__ */ o.jsx(c, { title: t, subtitle: e, cta: s }),
  i && /* @__PURE__ */ o.jsx("div", { className: "desktop", children: i })
] }) }) });
export {
  h as HeroSectionColumn
};
